import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../../../dto/data-model.js';
import { AuditLogEntry } from '../../audit-log-entry.js';
import { OnlineEventTicketOrder } from '../../../online-event-ticket-order.js';
import { MapUtils } from '../../../../../utility/map-utils.js';
import {
  cloneData, isSameData,
} from '../../../../dto/data-model-utils.js';
import { AuditLogEntryType } from '../../audit-log-entry-type.js';

export class OnlineEventTicketOrderAbortedEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = '4a4550f27c9644c3a11928866edbdc39';

  private constructor(
    public readonly before: OnlineEventTicketOrder,
    public readonly after: OnlineEventTicketOrder,
  ) {
    super();
  }

  get $typeId(): string {
    return OnlineEventTicketOrderAbortedEntry.TYPE_ID;
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.OnlineEventTicketOrderAborted;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      eventId: this.after.eventId,
      orderId: this.after.uniqueId,
      customerId: this.after.creatorId,
      isGuestOrder: this.after.isGuestOrder,
    };
  }

  static create(args: {
    before: OnlineEventTicketOrder,
    after: OnlineEventTicketOrder,
  }): OnlineEventTicketOrderAbortedEntry {
    return new OnlineEventTicketOrderAbortedEntry(
        args.before,
        args.after,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OnlineEventTicketOrderAbortedEntry {
    return this.create({
      before: context.fromData(MapUtils.getRecord(map, 'before')),
      after: context.fromData(MapUtils.getRecord(map, 'after')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      before: context.toData(this.before),
      after: context.toData(this.after),
    };
  }

  clone(): this {
    return OnlineEventTicketOrderAbortedEntry.create({
      before: cloneData(this.before),
      after: cloneData(this.after),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.before, this.before) &&
          isSameData(other.after, this.after);
  }
}

export class OnlineEventTicketOrderAbortedEntryBuilder extends DataModelBuilder<OnlineEventTicketOrderAbortedEntry> {
  build(context: SerializationContext, map: SerializedData): OnlineEventTicketOrderAbortedEntry {
    return OnlineEventTicketOrderAbortedEntry.fromMap(context, map);
  }
}
